module.exports = __webpack_public_path__ + "static/media/V1.0a2c2932.png";